const NavBar = (user) => {
  return (
    <nav className="navbar navbar-expand-md navbar-dark bg-dark mb-4">
      <div className="container">
        <div
          className={`col-sm-2 text-center ${user.registered && "col-6"}
          ${!user.registered && "col-12"}`}
        >
          <a href={global.config.url}>
            <img
              src={global.config.url + `/logo512.png`}
              alt="Quizmaster 3000"
              className="img-fluid"
              style={{ maxWidth: user.registered ? 100 : 150 }}
            />
          </a>
        </div>
        <div
          className={`col text-center ${
            user.registered && "d-none d-sm-block"
          }`}
        >
          <h1 className="navbar-brand text-center text-sm-left">
            Quizmaster 3000
            <br />
            <p className="small">
              A react based app built by{" "}
              <a
                href="http://www.aahunt.co.uk/"
                target="_blank"
                rel="noreferrer"
              >
                Ashley Hunt
              </a>
              .
            </p>
          </h1>
        </div>

        <div
          className={`navbar-collapse col text-center ${
            user.registered && "col-6"
          }`}
          id="navbarCollapse"
        >
          <ul className="navbar-nav mr-auto"></ul>
          {user.registered && (
            <div className="right">
              <ul className="navbar-nav mr-auto">
                <h4 className="text-light">
                  {user.name}
                  <span className="badge badge-primary badge-pill ml-2">
                    {user.score}
                  </span>
                </h4>
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  )
}

export default NavBar
